import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withTheme } from "@material-ui/core/styles";

import {
  CARD_FORM,
  CREATE_CARD_MODAL_ID,
} from "features/planner/planner.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import { createCardOnSubmit } from "features/planner/planner.actions";
import DummyCardForm from "features/planner/components/Card/DummyCardForm";

const CreateCardModalContainer = ({ dispatchCreateCardOnSubmit, theme }) => (
  <SimpleFormModal
    Icon={null}
    submitText="Create"
    title="Create Dummy Card"
    component={DummyCardForm}
    modalId={CREATE_CARD_MODAL_ID}
    onSubmit={dispatchCreateCardOnSubmit}
    form={{
      form: CARD_FORM.ID,
    }}
    FormProps={{
      theme,
    }}
  />
);

export default compose(
  connect(
    null,
    {
      dispatchCreateCardOnSubmit: createCardOnSubmit,
    },
  ),
  withTheme,
)(CreateCardModalContainer);
